import { render, staticRenderFns } from "./UserDetailSummary.vue?vue&type=template&id=c9ed99da&"
import script from "./UserDetailSummary.vue?vue&type=script&lang=js&"
export * from "./UserDetailSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports